import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'umi';
import { Input, Form, Bubble } from 'tea-component';
import SvgIcon from "@home/components/SvgIcon";
import classnames from 'classnames';
import { useSearchParamsState } from '@/pages/aigc/hooks/useQuery';
import { ADD_DASHBOARD } from '@/pages/datalab/pages/Home/GettingStart';
import { showErrorMessagetip } from "@home/components/ErrorMessageTip/ErrorMessageTip";

import './index.scss';

interface DashboardTitleProps {
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  validDashboardName: (name: string) => string;
  errorMessageRef: any;
}

export default React.memo((props: DashboardTitleProps) => {
  const { title, setTitle, errorMessageRef, validDashboardName } = props;
  const {formatMessage} = useIntl();
  const [inputVisible, setInputVisible] = useState(false); // 是否标题显示输入框
  const titleInputRef = useRef<HTMLInputElement | null>(null); // 获取输入框元素
  const [subTab] = useSearchParamsState('helpType', ''); // 指引
  useEffect(() => {
    if (inputVisible && titleInputRef.current) {
      titleInputRef.current.focus();
      titleInputRef.current.select();
    }
  }, [inputVisible]);
  
  return (
    <Form.Item
      label={''}
      showStatusIcon={false}
      status={errorMessageRef.current ? 'error' : 'validating'}
      className={'dbl-dashboard-edit-title'}
    >
      {
        inputVisible ?<Input
          className="dbl-dashboard-input"
          value={title}
          ref={titleInputRef}
          onChange={(value) => {
            setTitle(value);
          }}
          onBlur={() => {
            title?.trim() && setInputVisible(false);
            const message = validDashboardName?.(title);
            message && showErrorMessagetip({
              duration: 3000,
              errorCode: -1,
              content: message,
              isClose: true,
              type: 'error'
            });
          }}
        />: <div
          className={classnames({
            'dbl-datalab-guide-title': subTab === ADD_DASHBOARD,
            'dbl-datalab-guide-title-error': !!errorMessageRef.current
          })}
          onClick={(event: any) => {
            // eslint-disable-next-line eqeqeq
            if (event.detail == 2) {
              setInputVisible(true);
            } else {
              title?.trim() && setInputVisible(false);
            }
          }}
        >
          {title}
          <Bubble
            content={formatMessage({id: 'dbl_create_dashboard_tab_rename'})}
            dark
            placement={'right'}
            className={'dbl-tab-edit-icon-bubble'}
            // placementOffset={0}
          >
            <span>
              <SvgIcon type="pencil-m" className={'dbl-dashboard-edit-title-icon'} onClick={(event) => {
                event.stopPropagation();
                setInputVisible(true);
              }}/>
            </span>
  
          </Bubble>
        </div>
      }
    </Form.Item>
    
  );
});
